
import React from 'react';

const IndustryExpertiseSection: React.FC = () => {
  const industries = [
    {
      icon: 'ri-road-map-line',
      title: 'Heavy Civil Construction',
      description: 'Bridge construction, highway projects, tunnels, dams, and large-scale transportation infrastructure with specialized fall protection and confined space safety programs.'
    },
    {
      icon: 'ri-building-2-line',
      title: 'Structural Steel',
      description: 'High-rise construction, industrial facilities, and commercial steel fabrication with comprehensive welding safety and crane operation protocols.'
    },
    {
      icon: 'ri-train-line',
      title: 'Transportation Infrastructure',
      description: 'Railway systems, airport construction, port facilities, and mass transit projects requiring specialized safety management and regulatory compliance.'
    },
    {
      icon: 'ri-brush-line',
      title: 'Specialized Coating',
      description: 'Bridge painting, industrial coating, surface preparation, and protective coating applications with advanced respiratory protection and chemical safety.'
    },
    {
      icon: 'ri-building-line',
      title: 'General Construction',
      description: 'Commercial and residential construction projects with comprehensive safety programs covering all phases of construction activities.'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">
            Industry-Specific Expertise
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            We work with various industries, providing specialized OSHA consulting services tailored to each sector's unique safety challenges and regulatory requirements.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8">
          {industries.map((industry, index) => (
            <div key={index} className="bg-white rounded-lg p-6 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-line text-white text-xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {industry.title}
              </h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                {industry.description}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed">
                {industry.details}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a 
            href="#contact-form" 
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
          >
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
};

export default IndustryExpertiseSection;
